import { useQuery as s } from "react-query";
import { useEnvironment as n } from "../../../common/hooks/environment/useEnvironment.js";
import { useAuth as a } from "../../../auth/hooks/useAuth.js";
import { ScopeAdapter as i } from "../../models/scope/scope.adapter.js";
import { getAdapter as c } from "../../adapter.js";
const m = 4;
function h() {
  const {
    backendBaseUrl: e
  } = n(), {
    token: o,
    scope: r
  } = a(), t = c(i).toQueryString(r);
  return t.set("tag_type", m.toString()), s(
    ["customer-tags", o, t.toString()],
    async () => (await (await fetch(`${e}/customer/tag/?${t}`, {
      method: "GET",
      headers: {
        authorization: `Token ${o}`
      }
    })).json()).tag_list ?? []
  );
}
export {
  h as useCustomTags
};
//# sourceMappingURL=useCustomTags.js.map
